(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', 'AlertService'];

    function PasswordController (Auth, Principal, AlertService) {
        var vm = this;
        
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.duplicatePassword = null;
        vm.currentPasswordIncorrect = null;
        vm.authProvider = Auth.authProvider();

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            // Reset all error states
            vm.error = null;
            vm.success = null;
            vm.doNotMatch = null;
            vm.duplicatePassword = null;
            vm.currentPasswordIncorrect = null;
            
            if (vm.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
                return;
            }
            
            // Call the updated API with current password verification
            Auth.changePasswordWithCurrentPassword({
                currentPassword: vm.currentPassword,
                newPassword: vm.password
            }).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                if (response.status === 401) {
                    vm.currentPasswordIncorrect = 'ERROR';
                } else if (response.status === 400) {
                    vm.duplicatePassword = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
